// extracted by mini-css-extract-plugin
module.exports = {"background":"background_background_2OwPj"};